// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1bvyv","rootCenter":"LoadMoreObserver_rootCenter__2xI8t","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3BCYx"};